import { Pipe, PipeTransform } from '@angular/core';
import { FeedbackPriorityEnum } from '#models/enums/feedback/feedback-priority';

@Pipe({
    name: 'priority',
    standalone: false
})
export class FeedbackPriorityPipe implements PipeTransform {
    transform(value: string) {
        return FeedbackPriorityEnum.map.get(Number(value));
    }
}